import React, { Component } from "react";

import { toast } from 'react-toastify';

import { getFile } from "../../routes/lwocrytinstaller"

import LWOCryptBlock from "./LWOCrypt/LWOCryptBlock"
import LDDBlock from "./LDD/LDDBlock";
import CertBlock from "./CertBlock/CertBlock";
import LVPNBlock from "./LVPN/LVPNBlock";

const routeGetInstaller = "getinstaller"

const downloadFile = async (prog, os, file_name) => {
    const url = `/${routeGetInstaller}/${prog}/${os}/${file_name}`
    return await getFile(url).then(res => {
        if (res.status !== 200) {
            toast.error(<span style={{ fontSize: '15px' }} >
                Ошибка скачивания файла.
            </span>, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }
    })
}

class DownloadPage extends Component {
    constructor() {
        super();
        this.state = {
            blockLWOCryptIsOpen: false,
            blockLWOCryptWinIsOpen: false,
            blockLWOCryptLinuxIsOpen: false,
            blockLWOCryptMacIsOpen: false,
            blockLWOCryptIOSIsOpen: false,
            blockLWOCryptAndroidIsOpen: false,

            blockLVPNIsOpen: false,
            blockLVPNWinIsOpen: false,
            blockLVPNMacIsOpen: false,

            blockLDDIsOpen: false,

            blockLDDWinIsOpen: false,

            blockLDDMacIsOpen: false,
            spinnerIsViewGetCert: false,
            spinnerIsViewGetVPNFileClient: false,
        };
        ////
        this.openBlockLVPN = this.openBlockLVPN.bind(this);
        this.closeBlockLVPN = this.closeBlockLVPN.bind(this);

        this.openBlockLVPNWin = this.openBlockLVPNWin.bind(this);
        this.closeBlockLVPNWin = this.closeBlockLVPNWin.bind(this);

        this.openBlockLVPNMac = this.openBlockLVPNMac.bind(this);
        this.closeBlockLVPNMac = this.closeBlockLVPNMac.bind(this);
        ////

        ////
        this.openBlockLWOCrypt = this.openBlockLWOCrypt.bind(this);
        this.closeBlockLWOCrypt = this.closeBlockLWOCrypt.bind(this);

        this.openBlockLWOCryptWin = this.openBlockLWOCryptWin.bind(this);
        this.closeBlockLWOCryptWin = this.closeBlockLWOCryptWin.bind(this);

        this.openBlockLWOCryptMac = this.openBlockLWOCryptMac.bind(this);
        this.closeBlockLWOCryptMac = this.closeBlockLWOCryptMac.bind(this);

        this.openBlockLWOCryptLinux = this.openBlockLWOCryptLinux.bind(this);
        this.closeBlockLWOCryptLinux = this.closeBlockLWOCryptLinux.bind(this);

        this.openBlockLWOCryptIOS = this.openBlockLWOCryptIOS.bind(this);
        this.closeBlockLWOCryptIOS = this.closeBlockLWOCryptIOS.bind(this);

        this.openBlockLWOCryptAndroid = this.openBlockLWOCryptAndroid.bind(this);
        this.closeBlockLWOCryptAndroid = this.closeBlockLWOCryptAndroid.bind(this);
        ////

        ////

        this.openBlockLDD = this.openBlockLDD.bind(this);
        this.closeBlockLDD = this.closeBlockLDD.bind(this);

        this.openBlockLDDWin = this.openBlockLDDWin.bind(this);
        this.closeBlockLDDWin = this.closeBlockLDDWin.bind(this);


        this.openBlockLDDMac = this.openBlockLDDMac.bind(this);
        this.closeBlockLDDMac = this.closeBlockLDDMac.bind(this);
        ////

        this.onClickLWOCryptDownload = this.onClickLWOCryptDownload.bind(this);
        this.onClickGetCert = this.onClickGetCert.bind(this);

        this.onClickGetVPNClientFile = this.onClickGetVPNClientFile.bind(this);

        this.onClickLddDownload = this.onClickLddDownload.bind(this);

        this.onClickLVPNDownload = this.onClickLVPNDownload.bind(this);

    }

    ///
    /// begin LWOCrypt
    ///
    openBlockLWOCrypt() {
        this.setState({ blockLWOCryptIsOpen: true })
    }

    closeBlockLWOCrypt() {
        this.setState({ blockLWOCryptIsOpen: false })
        this.closeBlockLWOCryptAndroid()
        this.closeBlockLWOCryptIOS()
        this.closeBlockLWOCryptMac()
        this.closeBlockLWOCryptWin
        this.closeBlockLWOCryptLinux()
    }

    openBlockLWOCryptWin() {
        this.setState({ blockLWOCryptWinIsOpen: true })
    }
    closeBlockLWOCryptWin() {
        this.setState({ blockLWOCryptWinIsOpen: false })
    }

    openBlockLWOCryptLinux() {
        this.setState({ blockLWOCryptLinuxIsOpen: true })
    }
    closeBlockLWOCryptLinux() {
        this.setState({ blockLWOCryptLinuxIsOpen: false })
    }

    openBlockLWOCryptMac() {
        this.setState({ blockLWOCryptMacIsOpen: true })
    }
    closeBlockLWOCryptMac() {
        this.setState({ blockLWOCryptMacIsOpen: false })
    }

    openBlockLWOCryptIOS() {
        this.setState({ blockLWOCryptIOSIsOpen: true })
    }
    closeBlockLWOCryptIOS() {
        this.setState({ blockLWOCryptIOSIsOpen: false })
    }

    openBlockLWOCryptAndroid() {
        this.setState({ blockLWOCryptAndroidIsOpen: true })
    }
    closeBlockLWOCryptAndroid() {
        this.setState({ blockLWOCryptAndroidIsOpen: false })
    }
    ///
    /// End LWOCrypt
    ///


    ///
    /// begin LDD
    ///
    openBlockLDD() {
        this.setState({ blockLDDIsOpen: true })
    }

    closeBlockLDD() {
        this.setState({ blockLDDIsOpen: false })
        this.closeBlockLDDWin()
        this.closeBlockLDDMac()
    }

    openBlockLDDWin() {
        this.setState({ blockLDDWinIsOpen: true })
    }

    closeBlockLDDWin() {
        this.setState({ blockLDDWinIsOpen: false })
    }

    openBlockLDDMac() {
        this.setState({ blockLDDMacIsOpen: true })
    }

    closeBlockLDDMac() {
        this.setState({ blockLDDMacIsOpen: false })
    }
    ///
    /// end LDD
    ///


    ///
    /// begin LVPN
    ///
    openBlockLVPN() {
        this.setState({ blockLVPNIsOpen: true })
    }

    closeBlockLVPN() {
        this.setState({ blockLVPNIsOpen: false })
        this.closeBlockLVPNWin()
        this.closeBlockLVPNMac()
    }

    openBlockLVPNWin() {
        this.setState({ blockLVPNWinIsOpen: true })
    }

    closeBlockLVPNWin() {
        this.setState({ blockLVPNWinIsOpen: false })
    }

    openBlockLVPNMac() {
        this.setState({ blockLVPNMacIsOpen: true })
    }

    closeBlockLVPNMac() {
        this.setState({ blockLVPNMacIsOpen: false })
    }

    ///
    /// end LVPN
    ///

    onClickLWOCryptDownload(e) {
        try {
            return new Promise((resolve, reject) => {
                try {
                    const resDownload = downloadFile("lwocrypt", e.target.value, e.target.name)
                    resolve(resDownload)
                } catch (error) {
                    reject(error.response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    onClickGetCert() {
        try {
            this.setState({ spinnerIsViewGetCert: true })
            getFile("/getcerts").then(res => {
                if (res.status === 200) {
                    this.setState({ spinnerIsViewGetCert: false })

                } else {
                    this.setState({ spinnerIsViewGetCert: false })
                    toast.error(<span style={{ fontSize: '15px' }} >
                        Ошибка скачивания файла.
                    </span>, {
                        position: "top-right",
                        autoClose: 10000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    })
                }
            })
        } catch (error) {
            //console.log(error)
        }
    }


    onClickLddDownload(e) {
        try {
            return new Promise((resolve, reject) => {
                try {
                    const resDownload = downloadFile("ldd-installers", e.target.value, e.target.name)
                    resolve(resDownload)
                } catch (error) {
                    reject(error.response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    onClickLVPNDownload(e) {
        try {
            return new Promise((resolve, reject) => {
                try {
                    const resDownload = downloadFile("lvpn", e.target.value, e.target.name)
                    console.log(resDownload)
                    resolve(resDownload)
                } catch (error) {
                    reject(error.response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    onClickLddDocDownload() {
        try {
            const url = `./${routeGetInstaller}/ldd-installers/doc/lwo-digital-defense-client-docs.tar.gz`
            return new Promise((resolve, reject) => {
                try {
                    const resDownload = getFile(url).then(res => {
                        if (res.status !== 200)
                            toast.error(<span style={{ fontSize: '15px' }} >
                                Ошибка скачивания файла.
                            </span>, {
                                position: "top-right",
                                autoClose: 10000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "dark",
                            })
                    })
                    resolve(resDownload)
                } catch (error) {
                    reject(error.response)
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    onClickGetVPNClientFile() {
        try {
            return new Promise((resolve, reject) => {
                try {
                    const resDownload = getFile('/getvpnclientfile').then(res => {
                        if (res.status !== 200)
                            toast.error(
                                <span style={{ fontSize: '15px' }} >
                                    Ошибка скачивания файла.
                                </span>, {
                                position: "top-right",
                                autoClose: 10000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "dark",
                            })
                    })
                    resolve(resDownload)
                } catch (error) {
                    reject(error.response)
                }
            })
        } catch (error) {
            //console.log(error)
        }
    }


    render() {
        return (
            <div
                style={{
                    maxWidth: "800px",
                    marginTop: '20px',
                    textAlign: "justify",
                    animation: "fadeIn 1s",

                }}
                className="download-page">

                <CertBlock
                    spinnerIsViewGetCert={this.state.spinnerIsViewGetCert}
                    onClickGetCert={this.onClickGetCert}
                />

                <LDDBlock
                    blockLDDIsOpen={this.state.blockLDDIsOpen}
                    blockLDDWinIsOpen={this.state.blockLDDWinIsOpen}
                    blockLDDMacIsOpen={this.state.blockLDDMacIsOpen}

                    openBlockLDD={this.openBlockLDD}
                    closeBlockLDD={this.closeBlockLDD}

                    closeBlockLDDWin={this.closeBlockLDDWin}
                    openBlockLDDWin={this.openBlockLDDWin}

                    closeBlockLDDMac={this.closeBlockLDDMac}
                    openBlockLDDMac={this.openBlockLDDMac}

                    onClickLddDownload={this.onClickLddDownload}
                    onClickLddDocDownload={this.onClickLddDocDownload}
                />

                <LWOCryptBlock
                    blockLWOCryptIsOpen={this.state.blockLWOCryptIsOpen}
                    blockLWOCryptWinIsOpen={this.state.blockLWOCryptWinIsOpen}
                    blockLWOCryptLinuxIsOpen={this.state.blockLWOCryptLinuxIsOpen}
                    blockLWOCryptMacIsOpen={this.state.blockLWOCryptMacIsOpen}
                    blockLWOCryptIOSIsOpen={this.state.blockLWOCryptIOSIsOpen}
                    blockLWOCryptAndroidIsOpen={this.state.blockLWOCryptAndroidIsOpen}


                    closeBlockLWOCrypt={this.closeBlockLWOCrypt}
                    openBlockLWOCrypt={this.openBlockLWOCrypt}

                    closeBlockLWOCryptWin={this.closeBlockLWOCryptWin}
                    openBlockLWOCryptWin={this.openBlockLWOCryptWin}

                    closeBlockLWOCryptLinux={this.closeBlockLWOCryptLinux}
                    openBlockLWOCryptLinux={this.openBlockLWOCryptLinux}

                    closeBlockLWOCryptMac={this.closeBlockLWOCryptMac}
                    openBlockLWOCryptMac={this.openBlockLWOCryptMac}

                    closeBlockLWOCryptIOS={this.closeBlockLWOCryptIOS}
                    openBlockLWOCryptIOS={this.openBlockLWOCryptIOS}

                    closeBlockLWOCryptAndroid={this.closeBlockLWOCryptAndroid}
                    openBlockLWOCryptAndroid={this.openBlockLWOCryptAndroid}

                    onClickLWOCryptDownload={this.onClickLWOCryptDownload}
                />

                <LVPNBlock
                    blockLVPNIsOpen={this.state.blockLVPNIsOpen}
                    blockLVPNWinIsOpen={this.state.blockLVPNWinIsOpen}
                    blockLVPNMacIsOpen={this.state.blockLVPNMacIsOpen}

                    openBlockLVPN={this.openBlockLVPN}
                    closeBlockLVPN={this.closeBlockLVPN}

                    closeBlockLVPNWin={this.closeBlockLVPNWin}
                    openBlockLVPNWin={this.openBlockLVPNWin}
                    closeBlockLVPNMac={this.closeBlockLVPNMac}
                    openBlockLVPNMac={this.openBlockLVPNMac}

                    onClickLVPNDownload={this.onClickLVPNDownload}

                    onClickGetVPNClientFile={this.onClickGetVPNClientFile}
                />
            </div>
        );
    }
}

export default DownloadPage;
